import { supabase } from "@/lib/supabase";
import type { EditableCellValue } from "@/components/dashboard/EditableCell";

export const updateDomainField = async (
  id: string,
  column: string,
  value: EditableCellValue,
): Promise<void> => {
  let formattedValue = value;
  if (value === "") formattedValue = null;

  const { error } = await supabase
    .from("domains")
    .update({ [column]: formattedValue })
    .eq("id", id);

  if (error) {
    throw new Error((error as Error)?.message);
  }
};
